import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_ALT, MOCKUP_URL } from '../../data/images';

/** The offer — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-130" data-mp="2casnml5lce04">
      <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="28ai5yb8frz5f">
        <SectionHeading id="offer-heading" title={<>
              Everything Organized. <Accent data-id="element-133" data-mp="1yjnjp6v6wzjz">Everything in One Place.</Accent>
            </>} data-id="element-132" data-mp="28bl0ct4ywjq3" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(120,90,60,0.5)]" data-id="element-134" data-mp="2vyt1cyvd56mb">
          <div className="bg-brand-forest px-6 py-4 text-center" data-id="element-135" data-mp="2r6rtdp58a223">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-136" data-mp="3citdsv91he7a">
              Hair Extension Instructor Ready™ · by Prof. Kyra
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-137" data-mp="33of0uzbzefrc">
            <img src={MOCKUP_URL} alt={MOCKUP_ALT} width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[480px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(120, 90, 60, 0.18))'
          }} data-id="element-138" data-mp="33nngkknu44gd" />

            <p className="mt-10 text-center font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-gold-dark" data-id="element-139" data-mp="2ks6shmno9ort">
              What’s included
            </p>
            <ul className="mx-auto mt-5 grid max-w-2xl gap-x-8 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-140" data-mp="iyzfwkzg1l9m">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-141" data-mp="myqbd1zx0pkh">
                  <CheckIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-142" data-mp="1qyy1r0b6d99f" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-10 border-t border-brand-charcoal/10 pt-9" data-id="element-143" data-mp="1hxzzamgdx9sy">
              <CtaBlock label="Yes! I want my teaching system" showPrice data-id="element-144" data-mp="1i02y9vzimd9t" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}